import {
    APPOINTMENT_SCHEDULE_REQUEST, APPOINTMENT_SCHEDULE_RECEIVE, APPOINTMENT_SCHEDULE_FAILURE,
    SELECT_APPOINTMENT_SCHEDULE,
    SELECT_SERVICE,
    SELECT_CABINET,
    RESET_SCHEDULE,
    SELECT_GENDER
} from '../constants/schedule';


export const getSchedules = (data) => (dispatch) => {
    fetch(`/api/get-schedule/?id=${data.id}&offset=${data.offset}&gender=${data.gender}`)
        .then((response) => {
            response.json()
                .then((schedules) => {
                    dispatch({
                        type: APPOINTMENT_SCHEDULE_RECEIVE,
                        payload: {
                            schedules,
                            offset: data.offset
                        }
                    });
                    if (schedules.length === 1) {
                        dispatch(selectCabinet(schedules[0].cabinetId));
                    }
                });
        })
        .catch((error) => {
            dispatch({ type: APPOINTMENT_SCHEDULE_FAILURE });
        })
};

export const selectSchedule = (schedule) => (dispatch) => {
    dispatch({
        type: SELECT_APPOINTMENT_SCHEDULE,
        payload: schedule
    })
};

export const selectService = (serviceId) => (dispatch) => {
    dispatch({
        type: SELECT_SERVICE,
        payload: serviceId
    })
};

export const selectCabinet = (cabinetId) => (dispatch) => {
    dispatch({
        type: SELECT_CABINET,
        payload: cabinetId
    })
};

export const selectGender = (gender) => (dispatch) => {
    dispatch({
        type: SELECT_GENDER,
        payload: gender
    })
};

export const resetSchedule = () => (dispatch) => {
    dispatch({ type: RESET_SCHEDULE });
};



// WEBPACK FOOTER //
// frontend/src/modules/mobile/actions/schedule.js